import {
  ChangeDetectorRef,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { UiIconModel } from '@local/ui-infra';
import { getIconModel } from '@shared/utils/set-icon.util';
import { isPreviewClickAction, isWikiCard } from '../../utils/results.util';
import { PrimeTemplate } from 'primeng/api';
import { Action } from '../../models/view-filters';
import { Constants } from '@local/common';

export interface gallerySettings {
  showFooter?: boolean;
  showThumbnail?: boolean;
  showPreview?: boolean;
  showSummary?: boolean;
  showFavorite?: boolean;
  showDrag?: boolean;
  showCheckbox?: boolean;
  showInputTitle?: boolean;
  showBadge?: boolean;
}
const settingsDefault: gallerySettings = {
  showFooter: true,
  showThumbnail: true,
};
@Component({
  selector: 'gallery-view',
  templateUrl: './gallery-view.component.html',
  styleUrls: ['./gallery-view.component.scss'],
})
export class GalleryViewComponent implements OnInit {
  private _model;
  @Input() set model(value) {
    this._model = value;
    this.onChangeModel();
  }
  get model() {
    return this._model;
  }

  private _settings: gallerySettings = { ...settingsDefault };
  @Input() set settings(value: gallerySettings) {
    this._settings = { ...settingsDefault, ...value };
    this.cdr.markForCheck();
  }
  get settings(): gallerySettings {
    return this._settings;
  }

  @Input() thumbnail: string;
  @Input() defaultInputModel: string;
  @Input() inputPlaceholder: string;
  @Input() selected: boolean = false;
  @Input() checked: boolean = false;
  @Input() contextMenuActive: boolean;
  @Input() hovered: boolean;

  @Output() invoke = new EventEmitter<{ event: MouseEvent; type: string }>();

  @ViewChild('title', { read: ElementRef }) titleRef: ElementRef;
  @ContentChildren(PrimeTemplate) templates: QueryList<any>;
  dragItemTemplate: TemplateRef<any>;

  iconModel: UiIconModel;
  iconOverlayModel: UiIconModel;
  DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG = Constants.DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG;


  get tooltipTitleText(): string {
    const el: HTMLElement = this.titleRef?.nativeElement;
    if (!el) return;
    const width = el.clientWidth;
    const scrollWidth = el.scrollWidth;
    return width < scrollWidth ? this.model?.view?.title?.text : '';
  }

  constructor(protected cdr: ChangeDetectorRef) {}

  ngAfterContentInit() {
    this.templates.forEach((item) => {
      if (item.getType() === 'dragItem') {
        this.dragItemTemplate = item.template;
      }
    });
  }

  ngOnInit(): void {
    this.onChangeModel();
  }

  private onChangeModel() {
    this.iconModel = getIconModel(this.model?.view?.icon);
    this.iconOverlayModel = getIconModel(this.model?.view?.iconOverlay);
    if (this.model?.type === 'go-link') {
      this.iconModel = { type: 'font', value: 'icon-go-links' };
      this.iconOverlayModel = getIconModel(this.model?.view?.icon);
    } else if (isWikiCard(this.model)) {
      this.iconOverlayModel = { type: 'font', value: 'icon-card' };
    }
    this.cdr.markForCheck();
  }

  onClickFooter($event) {
    if (!this.settings.showInputTitle) {
      this.invoke.emit({ event: $event, type: 'title' });
    }
  }

  isPreviewClickAction(action: Action) {
    return isPreviewClickAction(action);
  }
}
